import Loading from '../../../Common/Loading';
import { usePriorityChartsDataContext } from './hooks/usePriorityChartsDataContext';
import { PriorityCalls } from './PriorityCalls';
import { PriorityCallsList } from './PriorityCallsList';

export const Charts = () => {
    const { isLoading } = usePriorityChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <PriorityCalls />
            <PriorityCallsList />
        </>
    );
};
